import { noPreviewImage } from '../../../../../../../constants/resource-constants';
import Image from '../../../../../../../models/image/Image';

export const getMainImageUrl = (image: Image) => {
	return image && image.urls && image.urls.uploaded && image.urls.uploaded.embed ? image.urls.uploaded.embed : noPreviewImage;
};
